<template>
<div class="page-box">
  <query-header
    ref="header"
    @add="addHandle"
    @toQuery="toQuery"
  ></query-header>
  <div class="page-content">
    <div class="vs-table-outer">
      <vs-table
        :data="listData"
      >
        <template
          slot="thead">
          <vs-th>
            ID
          </vs-th>
          <vs-th>
            名称
          </vs-th>
          <vs-th>
            Host
          </vs-th>
          <vs-th>
            Port
          </vs-th>
          <vs-th>
            安装路径
          </vs-th>
          <vs-th>
            状态
          </vs-th>
          <vs-th>
            创建时间
          </vs-th>
          <vs-th>
            更新时间
          </vs-th>
          <vs-th>
            操作
          </vs-th>
        </template>
        <template slot-scope="{data}">
          <vs-tr
            v-for="(tr, index) in data"
            :key="index"
          >
            <vs-td
              style="min-width: 50px;"
            >
              {{tr.id}}
            </vs-td>
            <vs-td>
              {{tr.apiName}}
            </vs-td>
            <vs-td>
              {{tr.apiHost}}
            </vs-td>
            <vs-td>
              {{tr.apiPort}}
            </vs-td>
            <vs-td>
              {{tr.wechatFilePath}}
            </vs-td>
            <vs-td
              style="min-width: 100px"
            >
              <span
                class="self-tag"
                :style="getstyle(tr)"
              >
                {{tr.status==0?'禁用':'启用'}}
              </span>
            </vs-td>
            <vs-td>
              {{parseTime(tr.createTime)}}
            </vs-td>
            <vs-td>
              {{parseTime(tr.updateTime)}}
            </vs-td>
            <vs-td>
              <el-button
                type="text"
                v-if="isAuth('wx:bot:api:update')"
                iconClass="edit-21"
                class="pointer mar-right10 icon-el pointer"
                @click.stop="editHandle(tr)"
              >修改</el-button>
            </vs-td>
          </vs-tr>
        </template>
      </vs-table>
    </div>
    <div class="pagination-outer" v-if="total">
      <div class="paginnation-left">
        <size-change @sizeChange="sizeChange"></size-change>
        <span class="tatol-count">合计 {{total}} 条</span>
      </div>
      <vs-pagination
        class="pagination-box"
        :max="max"
        :total="pageSize"
        v-model="page"
      ></vs-pagination>
    </div>
  </div>
  <edit-dialog
    :form-data="currentRow"
    :dialog-show="editDialogShow"
    @close="closeEditDialog"
    @edit-success="editSuccess"
  ></edit-dialog>
  <add-dialog
    :dialog-show="addDialogShow"
    @close="closeAddDialog"
    @add-success="addSuccess"
  ></add-dialog>
</div>
</template>

<script>
import {colorRgba} from "@/utils";
import addDialog from "@/components/sys/wechat-server/addDialog";
import editDialog from "@/components/sys/wechat-server/editDialog";
import queryHeader from "@/components/sys/wechat-server/queryHeader";
import { mapGetters } from 'vuex'
import { parseTime } from '@/utils'
import initData from "@/mixins/initData";

export default {
  name: "index",
  components: {
    queryHeader,
    editDialog,
    addDialog,
  },
  data() {
    return {
      red: '#D85E5F',
      green: '#41B883',
      editDialogShow: false,
      addDialogShow: false,
      currentRow: {},
    }
  },
  mixins: [initData],
  computed: {
    ...mapGetters(['themeColor','userInfo']),
  },
  mounted(){
    this.init();
  },
  methods: {
    parseTime,
    getstyle(tr){
      if(tr.status === 0){
        return {
          backgroundColor: colorRgba(this.red ,0.1),
          color: this.red,
        };
      }else {

        return {
          backgroundColor: colorRgba(this.green,0.1),
          color: this.green,
        };
      }
    },
    beforeInit(){
      this.url = '/wx/manage/wxBotApiConfig/list';
      this.params = {
        page: this.page,
        limit: this.size,
        'sidx': 'id',
        'order':'desc',
      }
      let header = this.$refs.header;
      if(header.status !== ''){
        this.params.status = header.status;
      }
      if(header.serveName){
        this.params.apiName = header.serveName;
      }
      return true;
    },
    addHandle(){
      setTimeout(() => {
        this.addDialogShow = true;
      },200);
    },
    closeAddDialog(){
      this.addDialogShow = false;
    },
    addSuccess(){
      this.addDialogShow = false;
      this.searchHandle();
    },
    editHandle(tr){
      this.currentRow = tr;
      setTimeout(() => {
        this.editDialogShow = true;
      },200);
    },
    searchHandle(){
      this.page = 1;
      this.init();
    },
    closeEditDialog(){
      this.currentRow = {};
      this.editDialogShow = false;
    },
    editSuccess(){
      this.currentRow = {};
      this.editDialogShow = false;
      this.searchHandle();
    },
  },
}
</script>

<style lang="scss" scoped>
.strategy-manager {
  .box-item {
    margin-bottom: 10px;
  }
  .btn {
    margin-right: 10px;
  }
  .vs-table-outer {
    .vs-con-table {
      min-width: 1200px;
    }
  }
  .tag-box {
    padding: 5px 10px;
    border-radius: 15px;
  }
  .reject-reason {
    max-width: 120px;
  }
}
</style>
